<section class="link-section" style="padding-bottom: 100px;">

  <div class="logo-div">
    <img src="../../../assets/imgs/logo.png" height="48" width="160"/>
  </div>

<div class="links-component container" style="color: var(--header-bgColor)!important;">

     <div  *ngFor="let link of links">

       <a style="color: var(--header-bgColor)!important"  [routerLink]="['/event/' , slugify(link.name), link.id ]" class="link-item-container col-md-7 row event-link-border">

          <div class="col-md-6 img-wrapper" style="margin-right: 0px;padding: 0">
            <img class="link-img img-mini"   src="{{eventImage(link) |assetimage}}" alt="" onError = "this.src = 'assets/imgs/banner.png'">
          </div>

          <div class="col-md-6 pd-tp-6 event-name-wrapper">
            <div style="line-height: 22px">
              <div class="font-size-17 two-line-text-hide"><b>{{link.name}}</b></div>
              <div class="date">{{link.start_date|datefrench1}} <span >à</span> {{link.start_hour | hourpipe}}</div>
            </div>
            <span class="font-size-14 location-adress-hidden">{{link.location_name+' '+link.adresse}}</span>
          </div>
       </a>
     </div>

      <div style="" class="col-md-7 discover-other-events discover-other-font-size"><a href="/" style="color: #00d7ff;font-weight: bolder;" class="link-button-mini">découvrez plus d'évènements</a> </div>

      <div style="background-color: #00d7ff;!important;color: white" class="col-md-7 discover-other-events discover-other-font-size"><a [routerLink]="['/manage/event/create']"  class="link-button-mini"  title="Créer un évènement" style="background-color: #00d7ff;!important;color: white">créez votre évènement</a> </div>

    </div>
</section>
